export default __webpack_public_path__ + "static/media/JS.a78cf911.png";